<template>
<div id="story">
  <BContainer class="page">
    <BRow>
      <BCol
        class="content-section"
        :lg="8"
        :sm="12">

        <div class="header">
          <h1 class="display-4 my-4">
            {{ storyLabel }}
          </h1>
        </div>
        <component
          v-if="file"
          :is="file"/>
        <div v-else class="description">
          story file missing
        </div>

      </BCol>

      <BCol
        :lg="4"
        :sm="12"
        class="related">
        <h5>
          Related projects
        </h5>
        <ul>
          <li
            v-for="r in related"
            :key="r.uid">
            <router-link
              :to="`/projects/${r.uid}`">
              {{ r.label }}
            </router-link>
          </li>
        </ul>
        <a
          class="clickable"
          @click="$router.go(-1)">
          (back)
        </a>
      </BCol>
    </BRow>
  </BContainer>

  <div
    class="modal"
    :class="{ visible: !!image }"
    v-if="image">
    <div class="modal-background">
      <a
        @click="closeImage">
        <BImg
          class="ignore screen-size"
          :src="`${image}`"/>
      </a>
    </div>
  </div>

  <ContactPanel
    :subject="storyData.uid">
    <h3>Want to hear more?</h3>
    <p>
      Drop us an email and we will be happy to share more.
    </p>
  </ContactPanel>

</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FullScreenImage from '@/mixins/FullScreenImage';
import ScrollIntoView from '@/mixins/ScrollIntoView';
import ContactPanel from '@/components/sections/ContactPanel';
import {
  BContainer,
  BRow,
  BCol,
  BImg,
} from 'bootstrap-vue'

export default {
  name: 'Story',
  mixins: [
    FullScreenImage,
    ScrollIntoView,
  ],
  props: {
    uid: String
  },
  data() {
    return {};
  },
  components: {
    ContactPanel,
    'b-container': BContainer,
    'b-row': BRow,
    'b-col': BCol,
    'b-img': BImg,
  },
  created() {
    this.pageView(`story/${this.uid}`)
  },
  watch: {
    uid(a){
      this.pageView(`story/${a}`)
    }
  },
  computed: {
    ...mapState([
      'articles',
      'projects'
    ]),
    storyData(){
      return this.articles.find( d => d.uid === this.uid);
    },
    storyLabel(){
      return this.storyData.label;
    },
    related(){
      const tags = this.storyData.tags||[];
      return this.projects
        .filter( d => d.tags.some( a => tags.includes(a)))
    },
    file(){
      if(!this.uid) return;
      try {
        var md = require(`@/stories/${this.uid}/content.md`).default;
        return md;
      } catch (err) {
        console.log('Couldnt load file', err)
      }
    }
  },
  methods: {
    ...mapActions([
      'pageView'
    ]),
  }
};
</script>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/markdown';

#story  {

  .header {
    text-transform: capitalize;
  }

  .modal {
    &.visible {
      display: block;
      background-color: rgba(0,0,0,0.7);

      img {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        max-width: 95%;
        max-height: 100%;
        margin: auto;
        overflow: auto;
      }
    }
  }

  .page {
    display: flex;
    //width: 60rem;
    margin: 0 auto;

    .related {
      //flex: 0 0 10rem;
      border-left: 1px solid rgba(0,0,0,0.1);
      padding-left: 1rem;
      margin-top: 5rem;
    }

    .content-section {
      min-height: 30rem;
      @include image;
    }

  }

}
</style>
